import React from 'react';

export default function PageContent(props) {
	return (
		<div className="main-content">
			<div className="page-content">
				<div className="container-fluid">{props.children}</div>
			</div>
		</div>
	);
}
